import { createApp } from 'vue'
import App from './App.vue'
import { Toast } from 'vant';
import 'vant/es/toast/style'; // Only import Toast style instead of full vant CSS

import { createRouter, createWebHistory } from 'vue-router';
// Lazy load route components for better initial load performance
const VideoPlayer = () => import(/* webpackChunkName: "video-player" */ './components/VideoPlayer.vue');
const VideoGrid = () => import(/* webpackChunkName: "video-grid" */ './components/VideoGrid.vue');
const HomePage = () => import(/* webpackChunkName: "home-page" */ './components/HomePage.vue');
const SearchPage = () => import(/* webpackChunkName: "search-page" */ './components/SearchPage.vue');
import { createStore } from 'vuex'
// Only import fontawesome core + solid icons instead of all icon sets
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import '@fortawesome/fontawesome-free/css/solid.css'




// 创建一个新的 store 实例
const store = createStore({
  state () {
    return {
      count: 0,
      isShowShare: false,
      videoUrl: '',
    }
  },
  mutations: {
    increment (state) {
      state.count++
    },
    showShare(state, payload) {
      state.isShowShare = payload.showShare
    },
    setVideoUrl(state, payload) {
      console.log("store set url :" + payload.videoUrl)
      state.videoUrl = payload.videoUrl
    }
  }
})
const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  scrollBehavior() {
    // Always scroll to top on route navigation
    return { top: 0 };
  },
  routes: [
    // 这里添加你的路由规则
    {
        path: '/video_player/:video_file_fath(.*)',
        name: 'VideoPlayer',
        component: VideoPlayer
    },
    {
      path: '/',
      name:'home',
      component:HomePage
    },
    {
        path:'/video_list/:folderPath(.*)',
        name: 'VideoGrid',
        component:VideoGrid
    },
    {
      path: '/search',
      name: 'Search',
      component: SearchPage
    },
    { path: '/:pathMatch(.*)*', component:VideoGrid } // 捕获所有未匹配的路由并重定向到主页
  ]
});
const app = createApp(App);

app.config.globalProperties.$appName = 'My App';
if (window.location.protocol === 'https:') {
  app.config.globalProperties.$apiHost = 'https://tianyihk.jiuxingtang.online/';
  app.config.globalProperties.$videoPathPrefix = 'https://tianyihk.jiuxingtang.online/d'
} else {
  app.config.globalProperties.$apiHost = 'http://43.161.236.205:5244/';
  app.config.globalProperties.$videoPathPrefix = 'http://43.161.236.205:5244/d'
}

// app.config.globalProperties.$picPathPrefix = 'https://video.jiuxingtang.online/pic/';
app.config.globalProperties.$picPathPrefix = '/pic/';
app.config.globalProperties.$shareHtml = 'http://test.zanmei.online/share.html';
app.config.globalProperties.$searchIgnorePath = '/sandisk/study';
app.use(router).use(store).use(Toast).mount('#app');

// app.use(store);